import { useCallback, useEffect, useState } from 'react'
import { supabase } from './supabase'
import { buildFamilies, jerseyDays } from './badges'

// Il catalogo cambia di rado: una sola lettura per sessione
let catalogCache = null
async function loadCatalog() {
  if (catalogCache) return catalogCache
  const { data, error } = await supabase
    .from('dim_badge')
    .select('id_badge, code, category, level, threshold, is_yearly, is_secret, icon_key, sort_order, badge_group')
    .order('sort_order')
  if (error) throw error
  catalogCache = data ?? []
  return catalogCache
}

// Badge di un giocatore in una lega: famiglie con livelli, avanzamento e rarita'.
// enabled = false se la lega non ha ancora i badge accesi (la sezione non va mostrata).
export function useBadges(leagueId, userId) {
  const [state, setState] = useState({ loading: true, error: false, enabled: false, families: [], days: { giro: 0, tour: 0, vuelta: 0 } })
  const [tick, setTick] = useState(0)
  const reload = useCallback(() => setTick(n => n + 1), [])

  useEffect(() => {
    if (!leagueId || !userId) return
    let cancelled = false
    setState(s => ({ ...s, loading: true, error: false }))
    ;(async () => {
      try {
        const lg = await supabase.from('dim_league').select('badges_enabled').eq('id_league', leagueId).maybeSingle()
        if (lg.error) throw lg.error
        if (!lg.data?.badges_enabled) { if (!cancelled) setState({ loading: false, error: false, enabled: false, families: [], days: { giro: 0, tour: 0, vuelta: 0 } }); return }
        const [catalog, earned, progress, stats] = await Promise.all([
          loadCatalog(),
          supabase.from('fact_user_badge').select('id_badge, awarded_at, season_year').eq('id_user', userId).eq('id_league', leagueId),
          supabase.from('fact_user_badge_progress').select('category, season_year, value').eq('id_user', userId).eq('id_league', leagueId),
          supabase.rpc('fn_league_badge_stats', { p_id_league: leagueId }),
        ])
        const bad = earned.error ?? progress.error ?? stats.error
        if (bad) throw bad
        const statMap = new Map((stats.data ?? []).map(s => [s.id_badge, s]))
        // se nessuno ha ancora un badge la RPC non da' righe: i membri servono lo stesso per la rarita'
        const families = buildFamilies(catalog, earned.data ?? [], progress.data ?? [], statMap)
        if (!cancelled) setState({ loading: false, error: false, enabled: true, families, days: jerseyDays(progress.data ?? []) })
      } catch {
        if (!cancelled) setState(s => ({ ...s, loading: false, error: true }))
      }
    })()
    return () => { cancelled = true }
  }, [leagueId, userId, tick])

  return { ...state, reload }
}
